import { Component, Input } from '@angular/core';

@Component({
  selector: 'aas-inline-header',
  templateUrl: './inline-header.component.html'
})
export class InlineHeaderComponent {

  @Input() hideHr: boolean = false;
  @Input() headerText: string = "";

  constructor() { }
}
